'use client';
import { useAuth } from '@bells/core/auth';
import { useLanguage } from '@bells/core/i18n';
import { authVerifySignin } from '@bells/i18n';
import { baseLocale } from '@bells/i18n/runtime';
import { User } from 'lucide-react';
import Link from 'next/link';
import { Button } from '../../../components/button';
import { getInitials } from '@bells/core/lib/initals';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '../../../components/avatar';

export const NavUser = () => {
  const { currentUser } = useAuth();
  const { language } = useLanguage();

  if (currentUser) {
    return (
      <Link
        prefetch={false}
        href={language == baseLocale ? `/settings` : `/${language}/settings`}
      >
        <Avatar className='size-10 rounded-full border'>
          <AvatarFallback className='rounded-full bg-white text-black'>
            {getInitials(currentUser?.name)}
          </AvatarFallback>
          {currentUser?.avatar && (
            <AvatarImage src={currentUser?.avatar}></AvatarImage>
          )}
        </Avatar>
      </Link>
    );
  }
  return (
    <Button
      size={'xs'}
      asChild
      className='hover:bg-brand hover:text-brand-foreground flex items-center gap-2 rounded-full bg-primary text-sm text-primary-foreground !opacity-100 transition-colors'
    >
      <Link
        prefetch={false}
        href={
          language == baseLocale
            ? `/auth/signin/customer`
            : `/${language}/auth/signin/customer`
        }
      >
        <User />
        <span className='hidden md:block'>{authVerifySignin()}</span>
      </Link>
    </Button>
  );
};
